import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./store";
import "./bootstrap.min.css";
import "./index.css";
import App from "./App";
import './theme.css';
import ComingSoon from "./components/ComingSoon";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
      {/* <ComingSoon/> */}
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
